<template>
  <div id="autoTableItem">
    <div>
      <Input
        style="cursor: pointer"
        readonly
        :placeholder="placeholder"
        :icon="icon"
        @on-focus="focus"
        @on-click="click"
      ></Input>
    </div>
    <div id="myPanel" class="customerSelect" v-show="showDropSelect">
      <div class="checkAll">
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="handleCheckAll"
          >全部</Checkbox
        >
      </div>
      <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
        <Checkbox
          :disabled="item.disabled"
          style="
            display: block;
            display: block;
            height: 32px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
          v-for="item in autoTableData"
          :label="item.id"
          :key="item.id"
        >
          <span :style="item.disabled === true ? 'color:#ccc' : ''">{{
            item.name
          }}</span>
        </Checkbox>
      </CheckboxGroup>
    </div>
  </div>
</template>
<script>
export default {
  name: "CRM_autoTableItem",
  props: ["placeholder", "defaultTable", "autoTableData", "type"],
  data() {
    return {
      icon: "ios-arrow-down",
      showDropSelect: false,
      indeterminate: false,
      checkAll: false,
      checkAllGroup: this.defaultTable, //初始化默认表格项
    };
  },
  mounted() {
    //初始化设置表格数据
    this.setData(this.checkAllGroup);
    let _this = this;
    document.addEventListener("click", function (e) {
      var e = e || window.event; //浏览器兼容性
      var elem = e.target || e.srcElement;
      while (elem) {
        //循环判断至跟节点，防止点击的是div子元素
        if (elem.id && elem.id == "autoTableItem") {
          return;
        }
        elem = elem.parentNode;
      }
      _this.showDropSelect = false;
      _this.icon = "ios-arrow-down";
    });
  },
  methods: {
    focus() {
      this.showDropSelect = true;
      this.icon = "ios-arrow-up";
    },
    click() {
      if (this.showDropSelect) {
        this.showDropSelect = false;
        this.icon = "ios-arrow-down";
      } else {
        this.showDropSelect = true;
        this.icon = "ios-arrow-up";
      }
    },
    //全选
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      let arr = [];
      let showText = "";
      for (let item of this.autoTableData) {
        arr.push(item.id);
        showText += "'" + item.name + "'" + "," + "//" + item.id + " \n ";
      }
      if (this.checkAll) {
        this.checkAllGroup = arr;
        console.log(showText);
        this.setData(arr);
      } else {
        // 不选中的时候判断是哪个表格的数据，返回固定项
        if (this.type == "myCustomer") {
          this.checkAllGroup = [
            "name",
            "phone",
            "member_status",
            "chankang_type_text",
            "follow_store_list",
            "my_store_group_list",
          ];
        } else if (this.type == "vipManagement") {
          this.checkAllGroup = [
            "name",
            "phone",
            "member_status",
            "chankang_type_text",
            "sign_store_list",
          ];
        } else if (this.type == "chainCustomer") {
          this.checkAllGroup = [
            "name",
            "phone",
            "member_status",
            "chankang_type_text",
            "follow_store_list",
            "follow_store_group_list",
            "sex_text",
            "follow_list",
            "follow_status",
            "allot_time",
            "channel_info_list",
            "agent_name_list",
            "enter_time",
            "come_status",
          ];
        } else if (this.type == "customerManagement") {
          this.checkAllGroup = [
            "name",
            "phone",
            "come_status",
            "member_status",
            "chankang_type_text",
            "follow_store_list",
            "my_store_group_list",
          ];
        } else if (this.type == "batchCustomer") {
          this.checkAllGroup = ["name", "phone"];
        } else if (this.type == "comeStat") {
          this.checkAllGroup = [
            "id",
            "name",
            "phone",
            "follow_store_list",
            "follow_list",
            "member_status",
            "child_birth",
            "budget",
            "come_date",
            "arrival_result",
          ];
        }
        this.setData(this.checkAllGroup);
      }
    },
    //监听选择
    checkAllGroupChange(data) {
      this.$emit("autoTableRef", data);
      if (data.length === this.autoTableData.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    setData(data) {
      if (this.type == "myCustomer") {
        //一共22项
        if (this.checkAllGroup.length == 22) {
          this.checkAll = true;
        }
      } else if (this.type == "vipManagement") {
      } else if (this.type == "chainCustomer") {
        if (this.checkAllGroup.length == 19) {
          this.checkAll = true;
        }
      } else if (this.type == "customerManagement") {
        if (this.checkAllGroup.length == 24) {
          this.checkAll = true;
        }
      }
      this.$emit("autoTableRef", data);
    },
  },
};
</script>
<style lang="" scoped>
.checkAll {
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
}
.customerSelect {
  width: 100%;
  position: absolute;
  top: 33px;
  left: 0;
  max-height: 200px;
  overflow: auto;
  margin: 5px 0;
  padding: 5px;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  z-index: 900;
}
</style>



// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_autoTableItem.vue